import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { buildSeo } from '../config/seo';

const setMeta = (selector, attribute, value) => {
    const element = document.head.querySelector(selector);
    if (element) element.setAttribute(attribute, value);
};

const Seo = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        const seo = buildSeo(pathname);
        document.title = seo.title;

        setMeta('meta[name="description"]', 'content', seo.description);
        setMeta('meta[name="robots"]', 'content', seo.noindex ? 'noindex, nofollow' : 'index, follow, max-image-preview:large');
        setMeta('link[rel="canonical"]', 'href', seo.canonical);
        setMeta('meta[property="og:url"]', 'content', seo.canonical);
        setMeta('meta[property="og:title"]', 'content', seo.title);
        setMeta('meta[property="og:description"]', 'content', seo.description);
        setMeta('meta[property="og:image"]', 'content', seo.image);
        setMeta('meta[name="twitter:url"]', 'content', seo.canonical);
        setMeta('meta[name="twitter:title"]', 'content', seo.title);
        setMeta('meta[name="twitter:description"]', 'content', seo.description);
        setMeta('meta[name="twitter:image"]', 'content', seo.image);
    }, [pathname]);

    return null;
};

export default Seo;
